import { CheckoutCompletedOfferConfirmation } from './checkout-completed-offer-confirmation.interface';
import { CheckoutCompletedQuoteConfirmation } from './checkout-completed-quote-confirmation.interface';
import { CheckoutCompletedRenewalConfirmation } from './checkout-completed-renewal-confirmation.interface';

export type CheckoutCompletedItemConfirmation =
  | CheckoutCompletedOfferConfirmation
  | CheckoutCompletedQuoteConfirmation
  | CheckoutCompletedRenewalConfirmation;
